import React from "react";
import twemoji from "@twemoji/api";
import {parse} from "@twemoji/parser";

const DEFAULT_IMAGE_CLASS = "inline-block vertical-align-middle w-1rem h-1rem";

export function isEmojiOnly(value) {
    const text = String(value ?? "");
    const entities = parse(text);
    if (!entities.length) return false;

    let cursor = 0;
    const hasNonEmojiContent = entities.some((entity) => {
        const [start, end] = entity.indices;
        const nonEmojiText = text.slice(cursor, start).trim();
        cursor = end;
        return Boolean(nonEmojiText);
    });

    return !hasNonEmojiContent && !text.slice(cursor).trim();
}

function TwemojiText({children, className = "", imageClassName = DEFAULT_IMAGE_CLASS, ...props}) {
    const text = String(children ?? "");
    const entities = parse(text);

    if (!entities.length) return <span className={className} {...props}>{text}</span>;

    const content = [];
    let cursor = 0;

    entities.forEach((entity, index) => {
        const [start, end] = entity.indices;
        if (start > cursor) content.push(text.slice(cursor, start));

        const assetName = entity.url.slice(entity.url.lastIndexOf("/") + 1);
        content.push(
            <img
                key={`${assetName}-${start}-${index}`}
                src={`${twemoji.base}svg/${assetName}`}
                alt={entity.text}
                draggable={false}
                loading="lazy"
                decoding="async"
                className={imageClassName}
            />
        );
        cursor = end;
    });

    if (cursor < text.length) content.push(text.slice(cursor));

    return <span className={className} {...props}>{content}</span>;
}

export default TwemojiText;
